<template>
  <aside class="main-sidebar">    
    <section class="sidebar m-t-20"> 
      <sidebar-menu />
    </section>
  </aside>
</template>
<script>
//import SidebarMenu from './SidebarMenu'
import SidebarMenu from './SidebarMenu.vue'

export default {
  name: 'Sidebar',
  components: { SidebarMenu },
  mounted: function () {
    window.jQuery('[data-toggle="hideseek"]').off().hideseek()
  },
}
</script>



// WEBPACK FOOTER //
// Sidebar.vue?e98f75cc